// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"4c232d60","758":"556075ac"}[chunkId] + ".chunk.css";
};